import { IMAGE_URL } from "config/Api";
import { AppCtx } from "data/context";
import React from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  userData: any;
}

const AboutProfile: React.FC<Props> = ({ userData }) => {
  const { setConnectWithMeUser } = React.useContext(AppCtx);
  let navigate = useNavigate();

  const onTap = () => {
    navigate(`/connect`);
    setConnectWithMeUser(userData);
  };

  // const onCreateProfile = () => {
  //   navigate(`/`);
  // };

  return (
    <>
      <div className="px-4 sm:px-10">
        <div className="relative flex justify-center pt-8 pb-6 sm:py-8">
          <div className="space-y-5">
            <img
              className="mx-auto h-36 w-36 rounded-full object-cover sm:h-40 sm:w-40"
              src={
                `${IMAGE_URL}${userData?.profile_pic}` || `/assets/images/profile/user.png`
              }
              alt="Profile"
            />

            <div
              className={`${
                userData?.background_pic === ""
                  ? "space-y-1 text-center"
                  : "space-y-1 text-center text-white"
              }`}
            >
              <h1 className="text-3xl font-medium sm:text-4xl">
                {userData?.profile_name || userData?.username}
              </h1>
              <p className="text-base font-medium sm:text-lg">
                {userData?.bio}
              </p>
            </div>
          </div>
        </div>

        {/*<div className="mb-6 flex justify-center">*/}
        {/*  <button*/}
        {/*    type="button"*/}
        {/*    className={`${*/}
        {/*      userData?.background_pic === ""*/}
        {/*        ? "w-40 rounded bg-gold py-3 px-2 text-sm"*/}
        {/*        : "w-40 rounded bg-white/30 py-3 px-2 text-sm text-white backdrop-blur-md"*/}
        {/*    }`}*/}
        {/*    onClick={() => onTap()}*/}
        {/*  >*/}
        {/*    Tap to Connect*/}
        {/*  </button>*/}
        {/*</div>*/}

        {/* {userData?.username !== "thelostlakefest" && (
          <div className="mb-6 flex justify-between sm:mx-auto sm:w-1/2">
            <button
              type="button"
              className={`${
                userData?.background_pic === ""
                  ? "w-40 rounded bg-gold py-3 px-2 text-sm"
                  : "w-40 rounded bg-white/30 py-3 px-2 text-sm text-white backdrop-blur-md"
              }`}
              onClick={() => onCreateProfile()}
            >
              Create Your Profile
            </button>
            <button
              type="button"
              className={`${
                userData?.background_pic === ""
                  ? "w-40 rounded bg-gold py-3 px-2 text-sm"
                  : "w-40 rounded bg-white/30 py-3 px-2 text-sm text-white backdrop-blur-md"
              }`}
              onClick={() => onTap()}
            >
              Tap To Connect
            </button>
          </div>
        )} */}
      </div>
    </>
  );
};

export default AboutProfile;
